import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { OffenseCodes } from '../models/offenseCodes';
import HttpBase from '../models/httpBase';
import EnvironmentService from '../services/environmentService';
import Offense from '../models/offense';
import OffenseSearch from '../models/offenseSearch';
import OffenseRecord from '../models/offenseRecord';
import HttpError from '../models/httpError';

@Injectable()
export default class OffenseService extends HttpBase {

  constructor(http: Http, router: Router, private environmentService: EnvironmentService) {
    super(http, router);
  }

  getOffense(requestNbr: number): Observable<any> {
    return this.httpGet(`${this.environmentService.getOffenses}\\?requestNbr=${requestNbr}`)
      .map((r: Response) => {
        if (r.status === 200) {
          return new Offense(OffenseSearch.createFromRequest(r.json().request),
          r.json().request.offenses === null ? null : OffenseRecord.getFromRequest(r.json().request.offenses));
        }

        return new HttpError(r, this.environmentService.getOffenses);
      });
  }

  save(offenseRecords: any): Observable<any> {
    return this.httpPost(this.environmentService.saveOffenses, offenseRecords)
    .map((r: Response) => {
      if (r.status !== 200) {

      }

      return OffenseCodes.ok;
    });
  }

  delete(requestNumber: number, offenceNumber: number): Observable<HttpError> {
    return this.httpDelete(`${this.environmentService.deleteOffense}\\${requestNumber}\\${offenceNumber}`)
    .map((r: Response) => {
      if (r.status !== 200) {
        return new HttpError(r, this.environmentService.saveOffenses);
      }

      return null;
    });
  }

  workOrderComplete(requestNumber: number, admittedCrimeNotFound: boolean): Observable<HttpError> {
    return this.httpPost(`${this.environmentService.workOrderComplete}`, { RequestNbr: requestNumber, admittedCrimeNotFound })
    .map((r: Response) => {
      if (r.status !== 200) {
        return new HttpError(r, this.environmentService.workOrderComplete);
      }

      return null;
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/offenseService.ts